import { Component, Input } from '@angular/core';
import { SectionComponent } from 'tuain-ng-forms-lib';

@Component({
  selector: 'app-section',
  templateUrl: './app-section.component.html',
})

export class AppSectionComponent extends SectionComponent {
  @Input() layout = 'inline';
  @Input() showHeader = false;
  @Input() showSubsectionHeaders = false;
  @Input() bordered = true;
  @Input() attributes: any = {};
}
